module.exports = __webpack_public_path__ + "e7.no2.e9efeecf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/e7.no2.jpg
// module id = /221
// module chunks = 0